__turbopack_context__.v({
  "text": "Text-module-scss-module__EcflOa__text",
});
